module.exports = __webpack_public_path__ + "img/next-arrow-bold.8638ca84.svg";